<template>
    <v-card
            class="drawing-card-blocked"
            max-width="300"
            :max-height="300">
        <v-overlay
                style="text-align: center;"
                absolute
                opacity="0.7">
            <v-btn
                    icon
                    x-large
                    @click="open">
                <v-icon>mdi-arrow-expand</v-icon>
            </v-btn><br>
            <span>Expand the image to start annotating</span>
        </v-overlay>
        <v-img
                :src="data || field.drawing.stencil.url"
                max-width="300"
                :max-height="300"
                :aspect-ratio="ratio"
                cover />
        <v-col
                v-if="error"
                dense
                cols="12"
                class="mt-2 pb-0 mb-2 pt-2">
            <v-messages
                    color="error"
                    :value="[error]" />
        </v-col>
        <component
                :is="drawingComponent()"
                ref="annotation"
                :open="openAnnotation"
                :default-color="field.drawing.default_color"
                :width="field.drawing.stencil.data.width"
                :height="field.drawing.stencil.data.height"
                :bg-src="field.drawing.stencil.url"
                @closed="close" />
    </v-card>
</template>

<script>
    import Field from "@/models/field.model";
    import Value from "@/models/value.model";
    import DrawingDialog from "@/views/Form/components/components/components/components/DrawingDialog.vue";
    import DrawingFullScreenView
        from "@/views/Form/components/components/components/components/DrawingFullScreenView.vue";

    export default {
        name: "FieldDrawingComponent",
        components: {DrawingDialog},
        props: {
            field: {type: Object, default: () => new Field({})},
        },
        data() {
            return {
                openAnnotation: false,
                value: null,
                error: null,
                data: null,
            }
        },
        computed: {
            ratio() {
                return this.field.drawing.stencil.data.height / this.field.drawing.stencil.data.width
            }
        },
        methods: {
            isMobile() {
                return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
            },
            fullscreenWebViewAvailable() {
                // FullScreen native mode
                // PS: Apple are bastards, so we can wait for the fix from their side
                // https://stackoverflow.com/questions/65802939/disable-pull-down-to-exit-full-screen-mode-on-safari-ios
                //
                // return this.isMobile() && (
                //     document.body.requestFullScreen
                //     || document.body.webkitRequestFullScreen
                //     || document.body.msRequestFullscreen
                //     || document.body.mozRequestFullScreen
                // );
                return false;
            },
            drawingComponent() {
                if (this.fullscreenWebViewAvailable()) {
                    return DrawingFullScreenView
                } else {
                    return DrawingDialog
                }
            },
            async getPopupZoom() {
                return new Promise((resolve) => {
                    const listener = (msg) => {
                        try {
                            const message = JSON.parse(msg.data);
                            if (message.source === 'gappt'
                                && message.action === 'urlPopupZoomACK'
                            ) {
                                complete(resolve, 1 * (message.zoom || 1));
                            }
                        } catch (e) {
                            //Ignored
                        }
                    };
                    let complete = (callback, value) => {
                        complete = () => {
                        };
                        window.removeEventListener('message', listener);
                        callback(value);
                    }
                    window.addEventListener('message', listener);
                    window.parent.postMessage(JSON.stringify({source: 'gappt', action: 'urlPopupZoom'}), '*');
                    setTimeout(() => complete(resolve, window.visualViewport ? window.visualViewport.scale : 1), 100);
                });
            },
            open() {
                this.openAnnotation = true;
            },
            async close(value) {
                this.openAnnotation = false;
                this.data = value
                const updatedValueObj = await this.getValue()
                this.$emit('updateValue', updatedValueObj);
            },
            async getValue() {
                this.error = null;

                const value = new Value({
                    value: this.data,
                    isValid: true
                });

                if (!this.field.is_optional && this.itemsNumber === 0) {
                    value.error = 'Mandatory field';
                    value.isValid = false;
                } else {
                    value.isValid = true;
                    value.error = null;
                }

                this.error = value.error;
                return value
            },
        }
    }
</script>